<template>
    <div>
        <div style="width: 100%">
            <div v-if="!printpage" class="bubble" :style="'left: calc(' + (props.lesson === 0 ? 0 : (props.lesson / props.max) * 100) + '% - 3vmin);'">
                {{ props.lesson }}
            </div>
            <div v-if="printpage" class="print_bubble" :style="'left: calc(' + (props.lesson === 0 ? 0 : (props.lesson / props.max) * 100) + '% - 2.165vmin);'">
                {{ props.lesson }}
            </div>
            <!-- <div style="width:3.2vmin;height: 3.2vmin;background-color: #8E43F0; border-radius: 50%; left: 10%;">
                  </div> -->
        </div>
        <div style="margin-top: -3px">
            <q-linear-progress track-color="grey-4" rounded :size="props.height + 'vmin'" :value="props.lesson === 0 ? 0 : props.lesson / 96" color="primary" class="q-mt-sm" />
        </div>
        <div style="width: 100%; display: flex; justify-content: space-between; font-size: 1.66vmin; margin-top: 0.2vw" :style="'color:' + textColor + ';'">
            <div>1레슨</div>
            <div>{{ props.max / 2 }}레슨</div>
            <div>{{ props.max }}레슨</div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, defineProps } from 'vue';

// const chartdiv = ref(null);
const props = defineProps({
    lesson: {
        default: 0,
    },
    max: {
        default: 96,
    },
    height: {
        default: 34,
    },
    color: {
        default: 'primary',
    },
    textColor: {
        default: '#8E8E8E',
    },
    printpage: {
        default: false,
    },
});

onMounted(() => {});
</script>

<style scoped lang="scss">
.bubble {
    position: relative;
    width: 6vmin;
    height: 6vmin;
    padding-top: 0.65vw;
    background-image: url('@/assets/images/icon/marker.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: center;
    font-weight: 700;
    // font-size: 2.2vmin;
    // font-size: 1.2vw;
    font-size: 1vw;
    color: white;
    text-align: center;
}

.rounded-borders {
    border-radius: 60px;
}

.print_bubble {
    position: relative;
    width: 5vmin;
    height: 5vmin;
    padding-top: 1vw;
    background-image: url('@/assets/images/icon/marker.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position-x: center;
    font-weight: 700;
    // font-size: 2.2vmin;
    // font-size: 1.2vw;
    font-size: 1.3vw;
    color: white;
    text-align: center;
}
</style>
